import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';

import './font/static/Heebo-Black.ttf';
import './font/static/Heebo-Bold.ttf';
import './font/static/Heebo-ExtraBold.ttf';
import './font/static/Heebo-ExtraLight.ttf';
import './font/static/Heebo-Light.ttf';
import './font/static/Heebo-Medium.ttf';
import './font/static/Heebo-Regular.ttf';
import './font/static/Heebo-SemiBold.ttf';
import './font/static/Heebo-Thin.ttf';


// ===================================================================
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
